







































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PartnerApi from '@/api/partner'
import PageLayout from '../../../components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '../../../mixins/list'
import { download } from '@/utils/util'
import store from '@/store'

@Component({
	name: 'partnerList',
	components: {
		PageLayout,
	},
	beforeRouteEnter(from, to, next) {
		if (store.getters.isSysadmin) {
			next()
		} else {
			next(`/partner/partnerDetail/${store.getters.userInfo.companyId}`)
		}
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	public getList() {
		return PartnerApi.getPartnerList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.getList()
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.createTime =
			form.startendTime &&
			form.startendTime[0] &&
			form.startendTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.startendTime &&
			form.startendTime[1] &&
			form.startendTime[1].format('YYYY-MM-DD')
		delete form.startendTime

		return form
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId).then((res: any) => {
					this.$message.success('发送成功')
					this.getList()
				})
			},
		})
	}

	private exportList() {
		this.exportingList = true
		TaskApi.exportList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
